export const SSO_PARTNERS = {
  EBILL: 'ebill',
  PRIME: 'prime',
  ALEGEUS: 'alegeus',
  OPTUM: 'optum',
  KYRUUS: 'kyruus',
  FITON: 'fiton',
  WIN: 'win',
  NOOM: 'noom',
  SAPPHIRE: 'sapphire',
  EXPRESS_RX: 'express_rx',
  AUTO_EXPRESS_RX: 'auto_express_rx',
  DAVISVISION: 'davisvision',
  SWORD: 'sword',
  BLOOM: 'bloom',
  AMWELL_CONVERGE: 'amwellconverge',
  SPRING_HEALTH: 'springhealth',
  KIDNEY_HEALTH: 'kidneyhealth',
  SMART_SHOPPER: 'smartshopper',
  MPPP: 'mppp',
  HEALTH_EQUITY: 'healthequity',
  MEMBER_EBILL: 'MEMBEREBILL',
} as const;

export const RETURN_URL = 'returnUrl=https://iel.member.highmark.com/error';
export const DEFAULT_REDIRECT_INFO = 'rxbenefits';

export type SsoPartner = typeof SSO_PARTNERS[keyof typeof SSO_PARTNERS];

export interface SsoConfig {
  partnerId: string;
  redirectInfo?: string;
  searchType?: string;
  relayStateUrl?: string;
}

export interface RxSsoResponse {
  payload: {
    ssoUrl: string;
    ssoFormParams: Array<{ name: string; value: string }>;
  };
}

export interface KyruusSearchMap {
  [normalizedSearchType: string]: string;
}
